<template>
  <div class="d-flex flex-grow-1 justify-center align-content-center">
    <Menu v-if="authenticated || isAuth"></Menu>
    <router-view></router-view>
    <Modal />
    <SnackbarNotification />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Modal from '@/components/utils/Modal.vue';
import Menu from '@/components/template/Menu.vue';
import SnackbarNotification from '@/components/utils/SnackbarNotification.vue';
import { getAuth } from "firebase/auth";

export default {
  components: {
    Modal,
    Menu,
    SnackbarNotification
  },
  props: {
    alert: Boolean
  },
  data () {
    return {
      isAuth: false
    }
  },
  computed: {
    ...mapGetters('main', ['authenticated']),
  },
  created(){
    const auth = getAuth();
    const user = auth.currentUser;
    this.isAuth = user || localStorage.getItem('autenticado_sistema')
    if(!this.isAuth){
      this.$router.push({ path: 'login' });
    }
  },
};
</script>

<style>
.hideMenu {
  margin-top: 60px;
}
</style>
